import * as yup from 'yup';

// Mirrors JobPostRequestValidator (API Models/Jobs/PostJobPostRequest.cs), so the
// server can no longer be the first thing to reject a title.
//
// The server rule is `Matches("^(?=.*[a-z]).+$").When(JobTitle.Length >= 5)`. That
// lookahead demands at least one LOWERCASE letter, i.e. it is anti-ALL-CAPS, not
// anti-lowercase: "sales manager" passes, "SALES MANAGER" fails. Titles under 5
// characters are exempt so CEO / CFO / COO still go through.
// Self-referencing .when() is a cyclic dependency in yup, hence .test().
const ALL_CAPS_EXEMPT_LENGTH = 5;
const CONTAINS_LOWERCASE = /^(?=.*[a-z]).+$/;

export const schema:any = yup.object().shape({
  jobTitle: yup.string().max(120, 'You have 120 characters remaining').nullable().required('The Job Title field is required.')
    .test(
      'not-all-caps',
      'The Job Title field cannot be in all capital letters.',
      (value) => !value || value.length < ALL_CAPS_EXEMPT_LENGTH || CONTAINS_LOWERCASE.test(value)
    ),
  companyName: yup.string().max(50, 'You have 50 characters remaining').nullable().required('The Company Name field is required.'),

  industrySectorId: yup.number().moreThan(0, 'The Job Category field is required.'),
  employmentTypeId: yup.number().moreThan(0, 'The Employment Type field is required.')

});
